/** Loot-container catalog. Interactable chests draw from the same recipe in both lid states. */
export const LOOT_PROP_TEMPLATES = {
  treasure_chest: { kind: 'trinket', name: 'treasure chest', frame: { w: 96, h: 76 }, band: 'vegetation' },
} as const;
